import { Component, OnInit } from '@angular/core';
import { FichaMedicaService } from '../../../../services/ficha-medica.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { FichaMedica } from '../../../../models/fichaMedica';
import { FichaMedicaEditarDialogComponent } from '../ficha-medica-editar-dialog/ficha-medica-editar-dialog.component';
import { FichaMedicaAvancesListComponent } from '../../fichaMedica-avances/ficha-medica-avances-list/ficha-medica-avances-list.component';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../../core/services/errores.service';
import { PersonalService } from '../../../../services/personal.service';
import { ClaseAusentismoService } from '../../../../services/clase-ausentismo.service';
import { RubrosService } from '../../../../services/rubros.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';


@Component({
  selector: 'app-ficha-medica-list',
  templateUrl: './ficha-medica-list.component.html',
  styleUrls: ['./ficha-medica-list.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class FichaMedicaListComponent implements OnInit {

  tituloTabla: string = "FichaMedica";
  fichas: FichaMedica[];
  eliminandoFicha: boolean;
  eliminacionInvalida: boolean;
  buscandoFichas: boolean;
  MensajeError: string;
  personalList: any;
  rubrosList: any;
  claseAusentismoList: any;
  mensajeExitoGuardado: string;

  rows: any;
  fichaInvalida: boolean;
  rowsExport: any;
  guardando: boolean;
  permisoEdicion: boolean = false;

  constructor(private fichaService: FichaMedicaService, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private rubrosService: RubrosService,
              private ausentismoSrv: ClaseAusentismoService,
              private personalService: PersonalService,
              private erroresService: ErroresService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.buscandoFichas = true;
    this.personalService.getAll().subscribe(data =>{this.personalList = data});
    this.rubrosService.getAll().subscribe(data =>{this.rubrosList = data});
    this.ausentismoSrv.getAll().subscribe(codigos => { this.claseAusentismoList = codigos});

    this.fichaService.getList().subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.fichas = data;
        this.rows = data;
        this.buscandoFichas = false;
        this.rowsExport = data.map(function(obj) {
          return {
            personal: obj.personal,
            rubro: obj.rubro,
            desde: obj.desde,
            hasta: obj.hasta,
            cantidad: obj.cantidad,
            certificado: obj.certificado,
            diagnostico: obj.diagnostico
          }
        });
      },
      error =>
      {
        this.erroresService.MostrarErrorByStatus(error, "Error al consultar");
        this.buscandoFichas = false;
      }
    );

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Ficha Medica")) this.permisoEdicion = true;
  }

  add(e)
  {
    let ficha: FichaMedica = {
      id: 0
    };

    this.abrirDialogo(ficha, 0);
  }

  abrirAvances(ficha: FichaMedica, index: number)
  {
    this.eliminacionInvalida = false;
    let dialogAvances = this.dialog.open(FichaMedicaAvancesListComponent, {
      width: '1000px',
      data: { param: ficha, permisoEdicion: this.permisoEdicion},
      disableClose: true
    });
  }

  abrirDialogo(ficha: FichaMedica, index: number)
  {
    this.eliminacionInvalida = false;
    let dialogRef = this.dialog.open(FichaMedicaEditarDialogComponent, {
      width: '700px',
      data: { param: ficha, permisoEdicion: this.permisoEdicion, 
              personalList: this.personalList,
              rubrosList: this.rubrosList,
              claseAusentismoList: this.claseAusentismoList },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result != '')
      {
        result.desde = this.momentService.convertDateServer(result.desde);
        result.hasta = this.momentService.convertDateServer(result.hasta);

        if (ficha.id == 0)
        {
          this.fichas.unshift(result);
          this.mensajeExitoGuardado = "Registro guardado";
        }
        else
        {
          this.fichas[index] = result;
          this.mensajeExitoGuardado = "Registro actualizado";
        }

        this.fichas = [...this.fichas];
        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
      }
    });
  }

  edit(row, rowIndex)
  {
    this.abrirDialogo(row, rowIndex);
  }

  delete(row)
  {

    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        this.eliminandoFicha = true;

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

    this.eliminandoFicha = true;
    this.fichaService.delete(row.id).subscribe(
      response =>
      {
        let index = this.fichas.findIndex(x => x.id == row.id);
        if (index != -1)
        {
          this.fichas.splice(index, 1);
          this.fichas = [...this.fichas];
        }

        this.snackBar.open("El registro se eliminó correctamente.", "OK", { duration: 10000 });    

        this.eliminandoFicha = false;

        setTimeout(function ()
        {
          dialogProcesandoRef.close();
        }); 
      },
      error =>
      {
        if (error.status == 400)
        {
          this.eliminacionInvalida = true;
          
          this.MensajeError = this.erroresService.MostrarError400(error);
        }
        else
        {
          this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
        }
        this.eliminandoFicha = false;
        dialogProcesandoRef.close();
      });}
    }); 
  }

  import(rowsImport){
    this.eliminacionInvalida = false;
    var count = 0;
    rowsImport.forEach((currentValue,index,arr) => {
      
      count++;
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let entidad: FichaMedica = {
        id: 0,
        personal: currentValue.personal,
        rubro: currentValue.rubro,
        desde: currentValue.desde,
        hasta: currentValue.hasta,
        cantidad: currentValue.cantidad,
        certificado: currentValue.certificado,
        diagnostico: currentValue.diagnostico
      }
      
      this.fichaService.save(entidad, false).subscribe(
        acumulador =>
        {
          setTimeout(function ()
          {
            this.guardandoPais = false;
            dialogProcesandoRef.close();
          });
        },
        error =>
        {
          this.guardando = false;
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
              this.fichaInvalida = true;
              this.MensajeError = error.error;
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });      
    });
    this.snackBar.open('Se procesaron ' + count + ' registros.' , "OK", { duration: 10000 });
  }
}
